import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  height: 35px;
  padding-left: 5px;
  margin: 0 4px;
  display: flex;
  align-items: center;
`;

export const StyledLabel = styled.label`
  font-family: inherit;
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  text-transform: capitalize;
  margin-left: ${({ theme }) => theme.spacing.s};
  color: ${({ theme }) => theme.colorsInObjects.gray[900]};
`;
